/* Shared vocabulary used across many screens: actions, statuses, table headers,
 * empty states, generic form labels. Keep feature-specific phrasing in the
 * feature chunk instead. */
const common = {
  // Actions
  'Save': 'Simpan',
  'Save changes': 'Simpan perubahan',
  'Cancel': 'Batal',
  'Close': 'Tutup',
  'Delete': 'Hapus',
  'Remove': 'Hapus',
  'Edit': 'Ubah',
  'Add': 'Tambah',
  'Create': 'Buat',
  'Back': 'Kembali',
  'Continue': 'Lanjut',
  'Next': 'Berikutnya',
  'Done': 'Selesai',
  'Search': 'Cari',
  'Search…': 'Cari…',
  'Filter': 'Filter',
  'Refresh': 'Muat ulang',
  'Download': 'Unduh',
  'Upload': 'Unggah',
  'Print': 'Cetak',
  'Submit': 'Ajukan',
  'Approve': 'Setujui',
  'Reject': 'Tolak',
  'Confirm': 'Konfirmasi',
  'Send': 'Kirim',
  'View': 'Lihat',
  'Retry': 'Coba lagi',
  'The server took too long to respond. Please try again.':
    'Server terlalu lama merespons. Silakan coba lagi.',
  'Loading…': 'Memuat…',
  'Saving…': 'Menyimpan…',
  'Yes': 'Ya',
  'No': 'Tidak',
  'OK': 'OK',
  'Copy': 'Salin',
  'Duplicate': 'Duplikat',
  'Export': 'Ekspor',
  'Import': 'Impor',
  'Actions': 'Tindakan',
  'More': 'Lainnya',
  'Clear': 'Bersihkan',
  'Apply': 'Terapkan',
  'Reset': 'Atur ulang',
  'Select': 'Pilih',
  'Select all': 'Pilih semua',
  'New': 'Baru',
  // Used as a status (open discrepancy/document), not as the verb "to open".
  'Open': 'Terbuka',

  // Statuses
  'Draft': 'Draf',
  'Pending': 'Menunggu',
  'Pending approval': 'Menunggu persetujuan',
  'In approval': 'Dalam persetujuan',
  'Approved': 'Disetujui',
  'Rejected': 'Ditolak',
  'Cancelled': 'Dibatalkan',
  'Completed': 'Selesai',
  'Closed': 'Ditutup',
  'Active': 'Aktif',
  'Inactive': 'Nonaktif',
  'Sent': 'Terkirim',
  'Received': 'Diterima',
  'Partially received': 'Diterima sebagian',
  'Paid': 'Dibayar',
  'Unpaid': 'Belum dibayar',
  'Overdue': 'Jatuh tempo',
  'Ready': 'Siap',
  'All': 'Semua',
  'All statuses': 'Semua status',

  // Table / list vocabulary
  'Name': 'Nama',
  'Description': 'Deskripsi',
  'Status': 'Status',
  'Date': 'Tanggal',
  'Created': 'Dibuat',
  'Updated': 'Diperbarui',
  'Created by': 'Dibuat oleh',
  'Total': 'Total',
  'Subtotal': 'Subtotal',
  'Amount': 'Jumlah',
  'Quantity': 'Kuantitas',
  'Qty': 'Kts',
  'Unit': 'Satuan',
  'Unit price': 'Harga satuan',
  'Price': 'Harga',
  'Currency': 'Mata uang',
  'Item': 'Barang',
  'Items': 'Barang',
  'Category': 'Kategori',
  'Categories': 'Kategori',
  'Supplier': 'Pemasok',
  'Suppliers': 'Pemasok',
  'Property': 'Properti',
  'Location': 'Lokasi',
  'Notes': 'Catatan',
  'Reference': 'Referensi',
  'Number': 'Nomor',
  'Type': 'Tipe',
  'Email': 'Email',
  'Phone': 'Telepon',
  'Address': 'Alamat',
  'Tax': 'Pajak',
  'Discount': 'Diskon',
  'No results': 'Tidak ada hasil',
  'No results found': 'Hasil tidak ditemukan',
  'Nothing here yet': 'Belum ada apa-apa di sini',
  'Optional': 'Opsional',
  'Required': 'Wajib',
  'Details': 'Detail',
  'Summary': 'Ringkasan',
  'History': 'Riwayat',
  'Activity': 'Aktivitas',
  'Attachments': 'Lampiran',
  'Comments': 'Komentar',
  'Today': 'Hari ini',
  'This week': 'Minggu ini',
  'This month': 'Bulan ini',
  'From': 'Dari',
  'To': 'Sampai',
  'Period': 'Periode',

  // Generic feedback
  'Something went wrong': 'Terjadi kesalahan',
  'Could not load data': 'Tidak dapat memuat data',
  'Changes saved': 'Perubahan disimpan',
  'Saved': 'Tersimpan',
  'Are you sure?': 'Apakah Anda yakin?',
  'This action cannot be undone.': 'Tindakan ini tidak dapat dibatalkan.',
};

export default common;
